import React from "react";
import { Link, useLocation } from "react-router-dom";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import moment from "moment";
import ClientButtonBar from "./ClientButtonBar";
import ProgramMiniCard from "./ProgramMiniCard";
import DocumentsIcon from "./DocumentsIcon";
import getAge from "../services/ageService";
import {
  getFieldDate,
  getFieldName,
  getFieldText,
} from "../../scripts/helperScripts";

const ClientMiniCard = ({ client }) => {
  const location = useLocation();

  //Render UI
  return (
    <div className="mb-2">
      <Card className="card-safy" style={{ height: "100%", margin: "0.5rem" }}>
        <Card.Header className="bg-safy1-1" style={{ color: "white" }}>
          <div className="row pe-2">
            <div className="col-10">
              <div className="h4 mt-0 mb-0 fw-light">
                {client.fullname} -{" "}
                {client.ccx_mpistr !== undefined ? (
                  client.ccx_mpistr
                ) : (
                  <span className="bg-danger px-1 text-white h5 rounded">
                    MISSING MPI
                  </span>
                )}
              </div>
            </div>
            <div className="col-2 p-0 d-flex justify-content-end">
              <Link
                id={client.ccx_mpistr}
                title="Open Client Program Record"
                to={`/client/${client.contactid.replace(/[{}]/g, "")}`}
                state={{
                  state: client,
                  previousPath: location.pathname,
                }}
              >
                <Button className="h-100 bg-safy3-1">
                  <i className="far fa-address-card fa-lg text-light"></i>
                </Button>
              </Link>
            </div>
          </div>
        </Card.Header>
        <Card.Body className="card-body-safy">
          <div className="row">
            <div className="col">
              {getFieldName(client.gendercode)}
              <br />
              DOB: {getFieldDate(client.birthdate)}
              <br />
              <br />
              <div>
                Age: <br />
                {client.birthdate &&
                  getAge(
                    getFieldDate(client.birthdate),
                    client.ccx_deceaseddate
                  )}
              </div>
            </div>
          </div>
        </Card.Body>
        <Card.Footer className="bg-safy1-1">
          <ClientButtonBar
            contactId={client.contactid}
            contactOwner={getFieldName(client.ownerid)}
            size="sm"
          />
        </Card.Footer>
      </Card>
    </div>
  );
};

export default ClientMiniCard;
